import { cmsCLient } from '@/services/axiosConfig'
import { GetAboutusInfoRes } from './types'

export type GetAboutusInfo = () => Promise<GetAboutusInfoRes>

export const getAboutusInfo: GetAboutusInfo = async () => {
  try {
    const response = await cmsCLient.get('/contents/about-us')

    return response.data
  } catch (e: any) {
    return e.message
  }
}
